import React from 'react'
import styled from 'styled-components'

interface SeparatorProps {
    orientation?: 'vertical' | 'horizontal'
    width?: string
    height?: string
    color?: string
    style?: React.CSSProperties
}

export const Separator = (props: SeparatorProps): JSX.Element => {
    const { color, orientation, width, height, style } = props

    return (
        <StyledSeparator
            orientation={orientation || 'vertical'}
            color={color || '#c8ccd4'}
            width={width || '1px'}
            height={height || '28px'}
            style={style || {}}
        />
    )
}

const StyledSeparator = styled.div<{
    orientation: 'vertical' | 'horizontal'
    width: string
    height: string
    color: string
}>`
    width: ${({ orientation, width }) => (orientation === 'horizontal' ? width || '28px' : '1px')};
    height: ${({ orientation, height }) => (orientation === 'vertical' ? height || '28px' : '1px')};

    background: ${({ color }) => color};

    margin: ${({ orientation }) => (orientation === 'horizontal' ? '24px 0' : '0 24px')};

    &:last-child {
        display: none;
    }
`
